module.exports = __webpack_public_path__ + "img/bq.6e0a056a.svg";